module.exports = __webpack_public_path__ + "3742fea25c4cbf26ccbe0a49d5180b08.jpg";